import { render, staticRenderFns } from "./DetachProductSetsContructModal.vue?vue&type=template&id=9232afb2&scoped=true&"
import script from "./DetachProductSetsContructModal.vue?vue&type=script&lang=js&"
export * from "./DetachProductSetsContructModal.vue?vue&type=script&lang=js&"
import style0 from "./DetachProductSetsContructModal.vue?vue&type=style&index=0&id=9232afb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9232afb2",
  null
  
)

component.options.__file = "DetachProductSetsContructModal.vue"
export default component.exports